import Vue from 'vue';

import VueMyseedCertificate from './vue-myseed-certificate.vue';

export default (el) =>
  new Vue({
    el,
    render: (h) => h(VueMyseedCertificate),
  });
